
	
import {ElLoading} from "element-plus";

const columnList: Array<any> = [
    {
        prop: "ordersn",
        label: "工单号",
        width: 150,
    },
    {
        prop: "settlement_time_text",
        label: "结算时间",
        width: 100,
    },
    {
        prop: "car_code",
        label: "车牌号",
        width: 100,
    },
    {
        prop: "model_name",
        label: "车型",
        width: 100,
    },
    {
        prop: "project_name",
        label: "项目",
        width: 100,
    },
    {
        prop: "salesman_name",
        label: "销售员",
        width: 100,
    },
    {
        prop: "sum_quoted_price",
        label: "报价金额",
        width: 100,
    },
    {
        prop: "sell_price",
        label: "销售金额",
        width: 100,
    },
    {
        prop: "sell_yj",
        label: "业绩",
        width: 100,
    },
    {
        prop: "sell_commission",
        label: "提成",
        width: 100,
    },

];
import {Request} from '@/api/request';

import {
    defineComponent,
    ref,
    reactive,
    inject,
    provide,
    onMounted,
    watch,
} from "vue";
import {getProjectSellExport, getPurchaseExport, getPurchaseTable, getSupplierList} from "@/api/http";
import { column } from "@/assets/types/common";
import {getFirstNowLastDay} from "@/api/date";

export default defineComponent({
    name: "projectSell",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["项目销售明细"]);
        let pageSize = ref(10),
            currentPage = ref(1),
            total = ref(0),
            tableData = ref([] as Array<any>),
            loading = ref(true),
            headClass = inject("headClass"),
            screenParameter =  reactive({
                time: [getFirstNowLastDay()[0],getFirstNowLastDay()[1]],
                page: 1,
                pagesize: 10,
                search: "",
				status: null,
                start_date: null,
                end_date: null,
                type_id: null,
                project_id: null,
                salesperson_id: null,
                single_display: null,
                single_display_: false,
            }),
 
			dialog_show = ref(false),
			form_isload = ref(false),
			form = ref({
				name: '',
				phone: '',
				nickname: '',
				position_id: '',
				branch_id: '',
				role_id: '',
				gender: '',
				qq: '',
				wechat: '',
				email: '',
				identity_number: '',
				address: '',
				entry_time: ''
			} as any),
            selectList = ref({
                project_type: [],
                project: []
            } as any),
            formRef = ref(null),
			formRules = {
				name: [{ required: true, message: '必填', trigger: 'blur'}],
				role_id: [{ required: true, message: '必填', trigger: 'changle'}],
				gender: [{ required: true, message: '必填', trigger: 'changle'}],
				nickname: [{ required: true, message: '必填', trigger: 'blur'}],
				position_id: [{ required: true, message: '必填', trigger: 'changle'}],
				branch_id: [{ required: true, message: '必填', trigger: 'changle'}],
			},
			form_positionList = ref([]),
			form_branchList = ref([]),
			form_roleList = ref([]),
			_addstaff = (): void => {
				dialog_show.value = true
				form_isload.value = true
				
				
				Request.axiosInstance({
					url: 'adminapi/Position/list',
					data: {status: 1}
				}).then((res: any) => {
					form_positionList.value = res?.content?.list || []
					Request.axiosInstance({
						url: 'adminapi/Role/list',
					}).then((res: any) => {
						form_roleList.value = res?.content?.list || []
						form_isload.value = false
					})
					
				})
			
				
			},
            screenChange = (e: any , key: any): void => {
                getTableData();
            },
			_uprowStatus = (id: number, status: number): void => {
				loading.value = true
				Request.axiosInstance({
					url: 'adminapi/Admin/upStateAdminStaff',
					data: {id: id, status: (status == 0 ? 1 : 0)}
				}).then((res: any) => {
					getTableData()
				})
			},
			_resetPassword = (id: number) => {
				
				if(!confirm("是否将该用户重置密码为123456")) return
				loading.value = true
				Request.axiosInstance({
					url: 'adminapi/Admin/resetPassword',
					data: {id: id}
				}).then((res: any) => {
					loading.value = false
				})
			},
            handleSizeChange = (size: number): void => {
                screenParameter.pagesize = size;
                getTableData();
            },
            handleCurrentChange = (page: number): void => {
                screenParameter.page = page;
                getTableData();
            },
            getSummaries = (param:any) => {
              const { columns, data } = param;
              const sums: any = [];
              const propArr = [
                "sum_quoted_price",
                "sell_price",
                "sell_yj",
                "sell_commission"
              ];
              columns.forEach((column: any, index: number) => {
                if (index === 0) {
                  sums[index] = "合计";
                  return;
                }
                const values = data.map((item: any) =>
                    Number(item[column.property])
                );
                if (
                    propArr.findIndex((item: any) => {
                      return item == column.property;
                    }) > -1
                ) {
                  // 增加合计项
                      if (column.property == "sum_quoted_price") {
                        sums[index] = selectList.value.total_sum_quoted_price;
                      } else if (column.property == "sell_price") {
                        sums[index] = selectList.value.total_sell_price;
                      } else if (column.property == "sell_yj") {
                        sums[index] = selectList.value.total_sell_yj;
                      } else if (column.property == "sell_commission") {
                        sums[index] = selectList.value.total_sell_commission;
                      }
                  if(column.property == "number"){
                    sums[index] = `${sums[index]}`;
                  }else{
                    sums[index] = `¥${sums[index]}`;
                  }
                } else {
                  sums[index] = "";
                }
              });
              return sums;
            },
            getTableData = (): void => {
                loading.value = true;
                let start_time = screenParameter.time?Math.floor(new Date(screenParameter.time[0]).getTime()/1000):"";
                let end_time = screenParameter.time ?Math.floor((new Date(screenParameter.time[1]).getTime()+24*60*60*1000-1)/1000):"";
                let data = {...screenParameter,start_time:start_time,end_time:end_time};
				Request.axiosInstance({
					url: 'adminapi/BusinessReport/projectSell',
					data: data
				}).then((res: any) => {
					tableData.value = res?.content?.list || [];
					loading.value = false;
                    total.value = res?.content?.total || 0;
          selectList.value.total_sell_price = res?.content?.total_sell_price;
          selectList.value.total_sum_quoted_price = res?.content?.total_sum_quoted_price;
          selectList.value.total_sell_yj = res?.content?.total_sell_yj;
          selectList.value.total_sell_commission = res?.content?.total_sell_commission;
				})
            },
            exportChange = () => {
              const loading = ElLoading.service({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)',
              });
              getProjectSellExport(screenParameter).then((res: any) => {
                //tableData.value = res?.content?.list || [];
                loading.close();
                const url = res.content;
                window.open(url);

              });
            },
          
            selectChange = (e: number): void => {
				console.log(e);
                getTableData();
            }

        onMounted(() => {

            Promise.all([
                Request.axiosInstance({
                    url: 'adminapi/Project/acquire',
                    data: {data: 'project_type_data'}
                }),
                Request.axiosInstance({
                    url: 'adminapi/Project/totalList',
                    data: {status: 1}
                }),
                Request.axiosInstance({
                    url: 'adminapi/OrderCar/constructors',
                }),
                
            ])
			.then((res: any) => {
				selectList.value.project_type = res[0]?.content?.list || []
                selectList.value.project = res[1]?.content?.list || []
                selectList.value.staff = res[2]?.content?.staff || []
				getTableData();
			})
            
        });

        return {
            columnList,
            tableData,
            loading,
            headClass,
            screen,
            total,
			handleSizeChange,
			handleCurrentChange,
            screenParameter,
            selectChange,
			dialog_show,
			form,
			formRef,
			formRules,
			form_isload,
			form_positionList,
			form_branchList,
			form_roleList,
			_addstaff,
			_uprowStatus,
			_resetPassword,
            screenChange,
            selectList,
          getSummaries,
          exportChange,
            currentPage,
            pageSize
        };
    },
});
